export const START = '[game] start';
export const RESET = '[game] reset';
export const PAUSE = '[game] pause';
export const RESUME = '[game] resume';
export const WIN = '[game] win';
export const TOGGLE_SOUND = '[game] toggle sound';
export const TOGGLE_DARK_MODE = '[game] toggle dark mode';
